const sounds = [
    {   name: 'piano chord1',
        link: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_1.mp3',
        letter: 'Q'
    },
    {   name: 'piano chord2',
        link: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_2.mp3',
        letter: 'W'
    },
    {   name: 'piano chord3',
        link: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_3.mp3',
        letter: 'E'
    },
    {   name: 'light',
        link: 'https://s3.amazonaws.com/freecodecamp/drums/Give_us_a_light.mp3',
        letter: 'A'
    },
    {   name: 'dry',
        link: 'https://s3.amazonaws.com/freecodecamp/drums/Dry_Ohh.mp3',
        letter: 'S'
    },
    {   name: 'blind',
        link: 'https://s3.amazonaws.com/freecodecamp/drums/Bld_H1.mp3',
        letter: 'D'
    },
    {   name: 'fight',
        link: 'https://s3.amazonaws.com/freecodecamp/drums/punchy_kick_1.mp3',
        letter: 'Z'
    },
    {   name: 'stick',
        link: 'https://s3.amazonaws.com/freecodecamp/drums/side_stick_1.mp3',
        letter: 'X'
    },
    {   name: 'snare',
        link: 'https://s3.amazonaws.com/freecodecamp/drums/Brk_Snr.mp3',
        letter: 'C'
    },

  ];

  export default sounds
